const _ = require('lodash');
const moment = require('moment');
const defaultState = {
    cc: [],
    ccDetail: {},
    loading: false,
    loadingHist: false,
    errors:{},
    lastFiltersCC: '',
    ccHist:[]
  }
  
export default (state=defaultState, action={}) => {
    switch (action.type) {

      case 'FETCH_CC_FULFILLED': {
        let arrayMain=[];
        let newItem = {};

        if(Array.isArray(action.payload.data)){
            action.payload.data.forEach((element,index) => {
                newItem = {};
                newItem = element;//limpa para criar um novo. Criamos campos com hora convertida para mostrar em local time no  export de Excel
                newItem["BEGIN_DATETIME_LOCAL"] = moment.utc(element.BEGIN_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');
                newItem["END_DATETIME_LOCAL"] = moment.utc(element.END_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');
                arrayMain.push(newItem);
            });
        }else{
            console.log('FETCH_CC_FULFILLED error: ');
            console.dir(action.payload.data);
        }
        return {
          ...state,
          cc: arrayMain,
          loading: false,
          errors: {}
        }
      }
  
      case 'FETCH_CC_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_CC_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }
  
      case 'FETCH_CC_DETAIL_FULFILLED': {

        const id = action.payload.data[0].ID;
        const status = action.payload.data[0].STATUS;
        const idFC = action.payload.data[0].ID_FC;

        return {
          ...state,
          ccDetail: action.payload.data[0],
          cc: state.cc.map(item => item.ID === id ? {...item, STATUS: status, ID_FC: idFC} : item),
          errors: {},
          loadingHist: false
        }
      }

      case 'FETCH_CC_DETAIL_PENDING': {
        return {
          ...state,
          loadingHist: true,
          ccDetail: {},
          errors: {}
        }
      }
      
      case 'FETCH_CC_DETAIL_REJECTED': {
        return {
          ...state,
          loadingHist: false,
          errors: { global: action.payload.message }
        }
      }      

      case 'LASTFILTER_CC': {      
        return {
          ...state,
          lastFiltersCC: action.payload
        }
      }

      case 'FETCH_CC_HISTORY_FULFILLED': {
        return {
          ...state,
          ccHist: action.payload.data,
          loadingHist: false,
          errors: {}
        }
      }
  
      case 'FETCH_CC_HISTORY_PENDING': {
        return {
          ...state,
          loadingHist: true,
          errors: {}
        }
      }
  
      case 'FETCH_CC_HISTORY_REJECTED': {
        return {
          ...state,
          loadingHist: false,
          errors: { global: action.payload.message }
        }
      }      

      case 'REFRESH_CC_LIST': {      
        const id = action.payload['rejectCCId'];
        const prevStatus = action.payload['rejectCCStatus'];
        let auxDetail = _.cloneDeep(state.ccDetail);
        auxDetail['STATUS'] = prevStatus;
        return {
          ...state,
          cc: state.cc.map(item => item.ID === id ? {...item, STATUS: prevStatus} : item),
          ccDetail: auxDetail
        }
      }

      //cases de refresh do state com base em sockets emitidos pelo server
      case 'DELETE_CC_FULFILLED': {
        const id = action.id;
        return {
            ...state,
            cc: state.cc.map(item => item.ID === id ? {...item, STATUS: 'Eliminada'} : item)
        }
      }

      case 'EDIT_CC_FULFILLED': {

        const id = action.editedRecord.ID;
        const auxEditedRecord = action.editedRecord;
        return {
            ...state,
            cc: state.cc.map(item => item.ID === id 
              ? auxEditedRecord 
              : item
              )
        }
      }

      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/cc-reducer.js